import { createContext, useState, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import EntityCondominium from '../entities/condominium.entity';

interface CondominiumContextProps {
  condominium: EntityCondominium | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setCondominium: React.Dispatch<React.SetStateAction<EntityCondominium | null>>;
  handleSelectCondominium: (newCondominium: EntityCondominium) => void;
  handleUnselectCondominium: () => void;
}

const CondominiumContext = createContext<CondominiumContextProps>({} as CondominiumContextProps);

export function useCondominiumContext() {
  return useContext(CondominiumContext);
}

export const CondominiumProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const history = useNavigate();
  const { pathname } = useLocation();

  const [condominium, setCondominium] = useState<EntityCondominium | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSelectCondominium = useCallback(
    (newCondominium: EntityCondominium) => {
      setCondominium(newCondominium);

      // Gets current condominium subpage
      const subPage = pathname.split('/')[3];

      const path = subPage ? `/condominiums/${newCondominium.id}/${subPage}` : `/condominiums/${newCondominium.id}`;

      history(path);
    },
    [history, pathname]
  );

  const handleUnselectCondominium = useCallback(() => {
    setCondominium(null);
    history('/condominiums');
  }, [history]);

  return (
    <CondominiumContext.Provider
      value={{
        condominium,
        loading,
        setCondominium,
        setLoading,
        handleSelectCondominium,
        handleUnselectCondominium,
      }}
    >
      {children}
    </CondominiumContext.Provider>
  );
};

export default CondominiumContext;
